export const loadCategories = () => ({
  type: 'FETCH_PRODUCT_CATEGORIES',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: '/v2/products/categories'
    }
  }
})



// WEBPACK FOOTER //
// ./src/App/MainMenu/TradeMenu/SubItems/ProductCategory/actions.js